<template>
  <AppLayout>
    <template #middle>
      <InnerContent>
        <PlatformProfile />
      </InnerContent>
    </template>
  </AppLayout>
</template>

<script setup lang="ts">
import AppLayout from '@/(routes)/(protected)/(app)/layout.vue'
import PlatformProfile from '@/features/admin/platform-setup/components/platform-profile.vue'
import InnerContent from '@/features/ui/components/inner-content/inner-content.vue'
</script>
